import styled from "styled-components";

const RightWrapPadding='30px';

export const VideoDialogContainer = styled.div`
  display: flex;
  flex-direction: row;
  max-height: 525px;
  min-height: 500px;
`

export const RightWrap = styled.div`
  width: 332px;
  min-width: 332px;
  overflow-y: auto;
`

export const ItemList = styled.ul`
  
`

export const CloseIcon = styled.img`
  width: 18px;
  height: 18px;
  position : absolute;
  top: 15px;
  right: 15px;
  cursor: pointer;
`
export const Icon = styled.img`
  width: 24px;
  height: 24px;
  margin-right: 10px;
`
export const Item = styled.li`
  list-style: none;
  display: flex;
  align-items: center;
  padding: 9px ${RightWrapPadding};
  cursor: ${props => props.isDisabled ? "default" : "pointer"};
  font-size: 14px;
  font-weight: 600;
  font-family: Pretendard;
  background-color: ${props => props.isDisabled ? "#eee" : "#fff"};
  &:hover{
    background-color: #efefef;
  }
  &:last-child{
    margin-bottom: 9px;
  }
`
export const PremiumIcon = styled.img`
  display: ${props => props.isDisplay ? "inline-block" : "none"} ;
  margin-left: 5px;
`

export const HeaderGridContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction:column;
  padding-bottom: 22px;
  position: relative;
  
  .closeBtn{
    width: 20px;
    right: 15px;
    top: 15px;
  }
  .closeBar1{
    width: 100%;
    left: 0;
  }
  .closeBar2{
    width: 100%;
    left: 0;
  }
`;

export const HeaderTitle = styled.div`
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  text-align: start;
  font-size: 20px;
  font-family: Pretendard;
  font-weight: 600;
  box-sizing: border-box;
`;

export const HeaderTitleWrap=styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  padding-top: ${RightWrapPadding};
  padding-left: ${RightWrapPadding};
  padding-right: ${RightWrapPadding};
`
export const TitleChageIcon = styled.img`
  width: 16px;
  margin-left: 8px;
  cursor: pointer;
`

export const HeaderSubTitle = styled.span`
  /* padding : 5px 0px 5px 5px; */
  text-align: start;
  font-size: 16px;
  font-family: Pretendard;
  font-weight: 400;
  padding-left: ${RightWrapPadding};
  padding-top: 5px;
  color : #252525;
`
export const WatermarkDescription = styled.span`
  padding-top : 2px;
  padding-left: ${RightWrapPadding};
  text-align: start;
  font-size: 14px;
  color : #858585;
`

export const HeaderDate = styled.div`
  grid-area: Date;
  padding-left: ${RightWrapPadding};
  padding-top: 10px;
  color: #252525;
  text-align: start;
  font-size: 14px;
  font-family: Pretendard;
  font-weight: 300;
`;

export const HeaderCloseDialogIcon = styled.img`
  grid-area: CloseIcon;
  justify-self: end;
  margin-right: 15px;
  margin-top: 15px;
`;

export const Video = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 847px;
  /* height: 100%; */
  min-width: 847px;
  max-height: 525px;
  background-color: #000;
  color: #fff;
  white-space: pre-wrap;
`;

export const DownloadButtonConatiner = styled.a`
  display: flex;
  justify-content: center;
  padding: 20px;
  align-items: center;
`;